const { $ } = window

function handleCareersListingsHover() {
	const listings = document.querySelectorAll('.cl--listing')

	if (!listings) {
		return
	}

	function handleActive(arr, listing) {
		arr.forEach((el) => {
			el.classList.remove('active')
		})
		listing.classList.add('active')
	}

	listings.forEach((listing, index) => {
		// for desktop
		listing.addEventListener('mouseover', (e) => {
			handleActive(listings, listing)
		})
		// for mobile
		listing.addEventListener('click', (e) => {
			handleActive(listings, listing)
		})
	})
}

function handleInfoAnimation() {
	const section = document.querySelector('.informational-slides--section')

	if (!section) {
		return
	}

	const btns = document.querySelectorAll('.info-slide-btn')
	const slides = document.querySelectorAll('.info-slide--wrap')

	btns.forEach((btn, index) => {
		btn.addEventListener('click', function (e) {
			if (btn.classList.contains('current')) {
				return
			}
			btns.forEach((el) => {
				el.classList.remove('current')
			})
			slides.forEach((el) => {
				el.classList.remove('active')
			})

			btn.classList.add('current')
			slides[index].classList.add('active')
		})
	})
}

function initializeHistorySlider() {
	const section = document.querySelector('.history-slider--section')
	if (!section) {
		return
	}

	$('.hs-slider--slides').slick({
		slidesToShow: 5,
		variableWidth: false,
		infinite: false,
		// centerMode: true,
		nextArrow: $('.slick-next'),
		prevArrow: $('.slick-previous'),
		responsive: [
			{
				breakpoint: 1920,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	})
}

function jobListings() {
	const $jobListingsWrap = $('.job-listings-wrap')
	if (!$jobListingsWrap.length || $('.job-listing-group').length < 2) {
		return
	}

	//either vertical or fade; cannot be both
	function initSlider() {
		$jobListingsWrap.slick({
			arrows: false,
			// cssEase: 'linear',
			// centerMode: true,
			dots: true,
			fade: true,
			infinite: true,
			speed: 300,
			// slidesToShow: num,
			// slidesToScroll: num,
			//! causes issues if items are not all same height
			// vertical: true,
			// verticalSwiping: true,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						arrows: true,
						appendArrows: '.slick-arrows-wrap',
						appendDots: '.slick-dots-wrap',
						nextArrow:
							'<button><svg aria-hidden="true" width="166" height="43" viewBox="0 0 166 43" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M73.9102 22.8031L88.4158 22.8031L82.8218 28.3794L84.1806 29.7559L92.0863 21.8325L84.1806 13.9268L82.8218 15.2679L88.4158 20.8619L73.9102 20.8619L73.9102 22.8031Z" fill="white"/> <rect x="0.75" y="-0.75" width="164.5" height="40.5" rx="9.25" transform="matrix(1 0 0 -1 0 41.3413)" stroke="white" stroke-width="1.5"/> </svg></button>',
						prevArrow:
							'<button><svg aria-hidden="true" width="166" height="43" viewBox="0 0 166 43" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M92.0898 20.8795L77.5842 20.8795L83.1782 15.3032L81.8194 13.9267L73.9137 21.8501L81.8194 29.7559L83.1782 28.4147L77.5842 22.8207L92.0898 22.8207L92.0898 20.8795Z" fill="white"/> <rect x="-0.75" y="0.75" width="164.5" height="40.5" rx="9.25" transform="matrix(-1 0 0 1 164.5 0.841309)" stroke="white" stroke-width="1.5"/> </svg> </button>',
					},
				},
			],
		})
	}

	initSlider()
	let t
	window.addEventListener('resize', function () {
		clearTimeout(t)
		t = setTimeout(function () {
			$('.job-listings-wrap.slick-initialized').slick('unslick')
			initSlider()
		}, 200)
	})
}

function CTAStudies() {
	const $CTASlider = $('.call-to-action-studies-slider')
	if (!$CTASlider.length) {
		return
	}
	$CTASlider.slick({
		arrows: false,
		dots: false,
		slidesToShow: 2,
	})
}

function initializePartnerSlider() {
	const $slider = $('.partners--carousel')
	if (!$slider.length) {
		return
	}

	$slider.slick({
		slidesToShow: 1,
		// slidestoScroll: 1,
		variableWidth: true,
		infinite: true,
		dots: false,
		arrows: false,
		initialSlide: 3,
		// centerMode: true,
		autoplay: true,
		autoplaySpeed: 1500,
		touchThreshold: 1000,
		waitForAnimate: false
	})

	
    $slider.find('.partner--wrap').on('mousedown', function() {
		$(this).css('cursor', 'grabbing');
	})

	$slider.find('.partner--wrap').on('mouseup', function() {
		$(this).css('cursor', 'grab');
	})
}

function initializeTestimonialRotator() {
	const $rotator = $('.testimonial-rotator--testimonials')
	if (!$rotator.length) {
		return
	}
	const $data = $('.testimonial-rotator--info')

	$rotator.slick({
		slidesToShow: 1,
		slidestoScroll: 1,
		infinite: true,
		dots: false,
		arrows: false,
		initialSlide: 3,
		//adaptiveHeight: true,
		asNavFor: $data,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
			  breakpoint: 600,
			  settings: {
				swipe: true, // Enable swipe/drag events on mobile
        		touchMove: false, // Enable touch events on mobile
			  }
			},
	  ],
	})

	if( $data ) {
		$data.slick({
			slidesToShow: 1,
			slidestoScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
			variableWidth: true,
			//adaptiveHeight: false,
			initialSlide: 3,
			centerMode: true,
			asNavFor: $rotator,
			focusOnSelect: true,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
				  breakpoint: 600,
				  settings: {
					swipe: true, // Enable swipe/drag events on mobile
					  touchMove: false, // Enable touch events on mobile
				  }
				},
		  ],
		})
	}
}

function initializeFeaturesSlider() {
	const $section = $('.features-slider--section')
	if (!$section.length) {
		return
	}

	const $slides = $('.features-slider--slides')
	const $images = $('.features-slider--images')
	$slides.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		fade: true,
		nextArrow: $('.slick-next'),
		prevArrow: $('.slick-prev'),
		appendDots: $('.fs-dots'),
		asNavFor: $images,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					adaptiveHeight: true,
				}
			}
		]
	})

	$images.slick({
		asNavFor: $slides,
		arrows: false,
		dots: false,
		fade: true,
	})


}

function initializeHSWalkthrough() {
	const $section = $('.heart-seat-walkthrough--section')

	if (!$section.length) {
		return
	}

	const $imageSlider = $('.hsw-image--slides')
	const $contentSlider = $('.hsw-content--slides')
	const $indexSlider = $('.hsw--nav .slick-dots')

	$imageSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.hsw-content--slides, .hsw--nav .slick-dots',
		fade: true,
		speed: 200,
		arrows: false,
		variableWidth: false,
		draggable: false,
	})

	$contentSlider.slick({
		asNavFor: '.hsw-image--slides, .hsw--nav .slick-dots',
		arrows: false,
		fade: true,
		dots: false,
		speed: 200,
		// appendDots: $('.hsw--nav'),
		variableWidth: false,
		// adaptiveHeight: true,
		// customPaging(slider, index) {
		// 	return `<button class="hws-dot--btn">0${index + 1}</button>`
		// },
	})

	$indexSlider.slick({
		asNavFor: '.hsw-image--slides, .hsw-content--slides',
		variableWidth: false,
		slidesToShow: 6,
		slidesToScroll: 1,
		focusOnSelect: true,
		dots: false,
		arrows: false,
		centerMode: false,
		infinite: false,
	})
}

function handleDualColumnCards() {
	const $section = $('.dual-column-cards--section')
	if (!$section.length) {
		return
	}

	const mgl = window.matchMedia('(max-width: 1024px)')
	const contents = document.querySelectorAll('.dcc--content')

	function removeActive(el) {
		el.classList.remove('active')
	}

	function addActive(el) {
		el.classList.add('active')
	}

	function toggleActive(element) {
		element.classList.contains('active')
			? removeActive(element)
			: addActive(element)
	}

	function handleActiveClassClick() {
		if (mgl.matches) {

			console.log('here1');
			// Select the elements with the class .dcc--figure
			// Select the elements with the class .dcc--figure
			const figures = document.querySelectorAll('.dcc--figure');

			// Calculate the midpoint of the viewport vertically
			const viewportMidpoint = window.innerHeight / 2 - 50;
		
			// Options for the IntersectionObserver
			const options = {
				threshold: [0, 1], // Trigger when element enters or exits the viewport
				rootMargin: `-${viewportMidpoint}px 0px`, // Adjust rootMargin to be half of viewport height
			};
		
			// Callback function to execute when intersection occurs
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					// Check if the element is within the middle 50% of the viewport
					console.log(entry.target);
					if (entry.isIntersecting) {
						$('.dcc--content').removeClass('active');
						$(entry.target).find('.dcc--content').addClass('active');
					} else {
						$(entry.target).find('.dcc--content').removeClass('active');
					}
				});
			};
		
			// Create a new IntersectionObserver
			const observer = new IntersectionObserver(callback, options);
		
			// Observe each .dcc--figure element
			figures.forEach(figure => {
				observer.observe(figure);
			});
			
			// contents.forEach((content) => {
			// 	content.addEventListener('click', () => {
			// 		toggleActive(content)
			// 	})
			// })
		} else {
			contents.forEach((content) => {
				content.removeEventListener(
					'click',
					() => {
						toggleActive(content)
					},
					false
				)
			})
		}
	}

	// function handleActiveClassHover() {
	// 	if (!mgl.matches) {
	// 		contents.forEach((content) => {
	// 			content.addEventListener('mouseover', function () {
	// 				addActive(content)
	// 			})
	// 			content.addEventListener('mouseout', function () {
	// 				removeActive(content)
	// 			})
	// 		})
	// 	} else {
	// 		contents.forEach((content) => {
	// 			content.removeEventListener(
	// 				'mouseover',
	// 				function () {
	// 					addActive(content)
	// 				},
	// 				false
	// 			)
	// 			content.removeEventListener(
	// 				'mouseout',
	// 				function () {
	// 					removeActive(content)
	// 				},
	// 				false
	// 			)
	// 		})
	// 	}
	// }

	handleActiveClassClick()
	// handleActiveClassHover()

	window.addEventListener('resize', function () {
		handleActiveClassClick()
		// handleActiveClassHover()
	})
}

function handleFLPArticles() {
	// const $articles = $('.flp-articles-article')
	// const $closeBtns = $('.flp-articles-article-content-container-right')

	// if (!$articles.length) {
	// 	return
	// }

	// $articles.each(function (index) {
	// 	$(this).on('click', function (e) {
	// 		$articles.each(function () {
	// 			$(this).removeClass('show').css('max-height',  ($(this).find('.flp-articles-article-title .font5').outerHeight() + 50) + 'px');
	// 		})

	// 		if (
	// 			e.target == $closeBtns[index] ||
	// 			e.target ==
	// 				$('.flp-articles-article-content-container-right svg')[index] ||
	// 			e.target == $('.m-md-only svg')[index]
	// 		) {
	// 			//$(this).removeClass('show')
	// 			$(this).removeClass('show').css('max-height', ($(this).find('.flp-articles-article-title .font5').outerHeight() + 50) + 'px');
	// 			//$(this).find('.flp-articles-article-content-container').fadeOut();
	// 		} else {
	// 			//console.log($(this).find('.flp-articles-article-content-container-middle'));
	// 			$(this).addClass('show').animate({'max-height': '1000px'});
	// 			//$(this).find('.flp-articles-article-content-container-middle').css('max-height', 'auto').css('height', 'auto').fadeIn();
	// 			//$(this).find('.flp-articles-article-content-container').fadeIn();
	// 		}
	// 	})
	// })
}

function runBlocks() {
	handleInfoAnimation()
	initializeHistorySlider()
	handleCareersListingsHover()
	handleDualColumnCards()
	initializePartnerSlider()
	initializeTestimonialRotator()
	initializeFeaturesSlider()
	initializeHSWalkthrough()
	// CTAStudies();
	jobListings()
	handleFLPArticles()
}

export { runBlocks }
